module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.sneakers), function(sneaker) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (sneaker.brand) + "/" + (sneaker.slug))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": sneaker.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sneaker.model_name))])])])], 1)
  }), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell sneaker-card"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (brand.name))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.hero_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(brand.name))])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('router-link', {
    staticClass: "button primary",
    attrs: {
      "to": {
        path: "/sneakers"
      }
    }
  }, [_vm._v("Go to all brands")])], 1)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-image"
  }, [_c('div', {
    staticClass: "header-overlay"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/flightclubny.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-text"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("My SNKR Collection")]), _vm._v(" "), _c('h2', {
    staticClass: "tagline"
  }, [_vm._v("your collection, everywhere")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h2', [_vm._v("Latest releases")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h2', [_vm._v("Popular brands")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb0049f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 72
// module chunks = 0